import type { JSX } from 'react'

import {
  BannerPaginationDotSC,
  BannerPaginationSC,
  BannerPaginationWrapperSC,
} from './BannerPagination.styled'

export interface IBannerPaginationProps {
  count: number
  activeIndex: number
  onSelect?: (index: number) => void
  dataTestId?: string
}

export const BannerPagination = ({
  count,
  activeIndex,
  onSelect,
  dataTestId,
}: IBannerPaginationProps): JSX.Element => {
  if (count <= 1) return <></>

  return (
    <BannerPaginationWrapperSC>
      <BannerPaginationSC data-testid={dataTestId}>
        {Array.from({ length: count }, (_, index) => (
          <BannerPaginationDotSC
            key={index}
            type='button'
            active={index === activeIndex}
            data-active={index === activeIndex}
            aria-label={`Go to banner ${index + 1}`}
            aria-current={index === activeIndex ? true : undefined}
            onClick={() => onSelect?.(index)}
          />
        ))}
      </BannerPaginationSC>
    </BannerPaginationWrapperSC>
  )
}
